import React, { useState, useEffect } from "react";
import "./Header.scss";
import { socialMediaLinks } from "../../portfolio";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  // Simplified header without dark mode toggle

  // Debug function to check all section IDs
  useEffect(() => {
    // Log all section IDs for debugging
    console.log('Checking section IDs:');
    ['home', 'projects', 'experience-education', 'technical-skills', 'certifications', 'blogs', 'gallery', 'contact'].forEach(id => {
      const element = document.getElementById(id);
      console.log(`Section #${id}: ${element ? 'Found' : 'NOT FOUND'}`);
    });
  }, []);

  // Handle scroll event to change header appearance and detect active section
  useEffect(() => {
    const handleScroll = () => {
      // Update header appearance
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }

      // Detect which section is in view
      const sections = [
        { id: 'home', element: document.getElementById('home') },
        { id: 'projects', element: document.getElementById('projects') },
        { id: 'experience-education', element: document.getElementById('experience-education') },
        { id: 'technical-skills', element: document.getElementById('technical-skills') },
        { id: 'certifications', element: document.getElementById('certifications') },
        { id: 'blogs', element: document.getElementById('blogs') },
        { id: 'gallery', element: document.getElementById('gallery') },
        { id: 'contact', element: document.getElementById('contact') }
      ];

      // Find the section that is currently in view
      const currentSection = sections.find(section => {
        if (!section.element) return false;

        const rect = section.element.getBoundingClientRect();
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;

        // Consider a section in view if its top is in the viewport or if it's the first section
        return (rect.top <= 150 && rect.bottom >= 150) ||
               (section.id === 'home' && rect.top <= windowHeight && rect.bottom >= 0);
      });

      if (currentSection) {
        setActiveSection(currentSection.id);
      }
    };

    window.addEventListener('scroll', handleScroll);
    // Call once on mount to set initial active section
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);



  // Smooth scroll function
  const scrollToSection = (sectionId) => {
    console.log('Scrolling to section:', sectionId);

    // Update active section immediately for better UX
    setActiveSection(sectionId);

    // Use the fixed navigation function if available
    if (window.fixedScrollToSection) {
      console.log('Using fixed navigation function');
      return window.fixedScrollToSection(sectionId);
    }

    // Fallback to our own implementation
    // Special case for home section
    if (sectionId === 'home') {
      console.log('Scrolling to top');
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      return;
    }

    // Try to find the section
    const section = document.getElementById(sectionId);
    if (section) {
      // Calculate position accounting for header height
      const headerHeight = 80; // Adjust based on your header height
      const sectionPosition = section.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = sectionPosition - headerHeight;

      console.log('Found section, scrolling to:', offsetPosition);

      // Scroll to the section
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    } else {
      console.warn('Section not found:', sectionId);

      // Try alternative selectors as fallback
      const alternativeSelectors = [
        `.section#${sectionId}`,
        `section#${sectionId}`,
        `div#${sectionId}`,
        `#${sectionId}`
      ];

      for (const selector of alternativeSelectors) {
        const element = document.querySelector(selector);
        if (element) {
          console.log('Found section using alternative selector:', selector);
          const headerHeight = 80;
          const sectionPosition = element.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = sectionPosition - headerHeight;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
          return;
        }
      }
    }
  };

  // Removed toggleDarkMode function as we no longer have a theme toggle button

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <div className="nav-content">
          <a href="#home" className="nav-logo">
            Niyanta Pandey
          </a>

          <nav className="nav-menu">
            <a href="#home" className={`nav-link ${activeSection === 'home' ? 'active' : ''}`}>About</a>
            <a href="#projects" className={`nav-link ${activeSection === 'projects' ? 'active' : ''}`}>Projects</a>
            <a href="#experience-education" className={`nav-link ${activeSection === 'experience-education' ? 'active' : ''}`}>Experience</a>
            <a href="#technical-skills" className={`nav-link ${activeSection === 'technical-skills' ? 'active' : ''}`}>Tech Stack</a>
            <a href="#certifications" className={`nav-link ${activeSection === 'certifications' ? 'active' : ''}`}>Certifications</a>
            <a href="#blogs" className={`nav-link ${activeSection === 'blogs' ? 'active' : ''}`}>Blogs</a>
            <a href="#gallery" className={`nav-link ${activeSection === 'gallery' ? 'active' : ''}`}>Gallery</a>
            <a href="#contact" className={`nav-link ${activeSection === 'contact' ? 'active' : ''}`}>Contact</a>
          </nav>
        </div>
      </div>
    </header>
  );
}
export default Header;
